export const fetchWithTimeout = (url, options, timeout = 3000) => {
  return Promise.race([
      fetch(url, options),
      new Promise((_, reject) =>
          setTimeout(() => reject(new Error('timeout')), timeout)
      )
  ]);
};


// WEBPACK FOOTER //
// ./src/utils/apiTimeoutHelper.js